import { IContact } from "./contact.model";
export class ICompany {
    isSelected: boolean;
    id: string;
    name: string;
    notes: string;
    contacts: IContact[];
    defaultContact: IContact;
    constructor(){
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/company.model.ts